import React from 'react'
import MatchHistoryLayout from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryLayout'
import MatchHistorySearch from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistorySearch'
import { RIGHTSHOLDER_SUB_ROUTES } from '@App/navigation/route'
import MatchHistoryViewRecordingGroups from '@Scenes/RightsholderScene/MatchHistory/v2/MatchHistoryViewRecordingGroups'

const createMatchHistoryRoutes = () => ({
    path: '',
    element: <MatchHistoryLayout />,
    children: [
        {
            path: RIGHTSHOLDER_SUB_ROUTES.matchHistory.root,
            element: <MatchHistorySearch />,
        },
        {
            path: RIGHTSHOLDER_SUB_ROUTES.matchHistory.submission,
            element: <MatchHistoryViewRecordingGroups />,
        },
    ],
})

export default createMatchHistoryRoutes
